<script setup lang="ts">
const { $sitemap } = useSitemap();
const route = useRoute();

const crumbs = ref<SitemapNode[]>([]);
const extraCrumb = ref<string>('');

const allCrumbs = computed(() =>
{
    if (extraCrumb.value)
    {
        return crumbs.value;
    }

    return crumbs.value.slice(0, -1);
});

const lastCrumb = computed<SitemapNode | null>(() =>
{
    if (extraCrumb.value)
    {
        return {
            name: extraCrumb.value,
            visible: true,
            allowed: true
        };
    }

    return crumbs.value[crumbs.value.length - 1] || null;
});

function url(node: any): any
{
    return $sitemap.url(node, route);
}

watch(() => $sitemap.extraCrumb, (value: string) =>
{
    extraCrumb.value = value;
});

watch(route, async (newRoute) =>
{
    $sitemap.append('');
    crumbs.value = await $sitemap.crumbs(newRoute);
},
{ immediate: true });
</script>

<template>
    <div id="breadcrumbs" class="d-flex px-3 pt-2 me-1">
        <div class="flex-fill d-flex align-items-center">
            <h3 v-if="lastCrumb" class="text-body-emphasis d-none d-lg-block m-0">
                {{ $t(lastCrumb.name) }}
            </h3>
            <div class="ms-lg-auto">
                <PortalTarget name="breadcrumbs" />
                <template v-if="allCrumbs.length > 0">
                    <template v-for="(item, index) in allCrumbs" :key="index">
                        <RouterLink class="link" :to="url(item)">{{ $t(item.name) }}</RouterLink>
                    </template>
                    <RouterLink v-if="lastCrumb" class="link active" :to="url(lastCrumb)">{{ $t(lastCrumb.name) }}</RouterLink>
                </template>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
#breadcrumbs {
    height: var(--ideo-breadcrumbs-height);

    .link {
        color: var(--bs-body-color);

        &:not(.separator) {
            cursor: pointer;
        }

        &.active {
            color: var(--bs-primary);
            font-weight: 500;
        }

        &:not(:last-child)::after {
            content: "\f324";
            font-family: var(--fa-font-family);
            font-size: 8px;
            vertical-align: 1px;
            display: inline-block;
            color: var(--bs-gray-400);
            padding: 0 8px;
        }
    }
}
</style>
